export default "__VITE_ASSET__AyKk9gHl__"